// ===== アニメーション発火 =====
	const animaElements = document.querySelectorAll("[data-scroll-anima]:not(.js-change)");
	const animaObserver = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (entry.isIntersecting) entry.target.dataset.scrollAnima = 'true';
		});
	}, { root: null, rootMargin: '0px', threshold: .1 });
	animaElements.forEach(el => animaObserver.observe(el));

document.addEventListener('DOMContentLoaded', () => {
  const btns = document.querySelectorAll('.js-changebtn');
  const wrapper = document.querySelector('.grigri-lead_wrapper');

  if (!btns.length || !wrapper) return;

  const updateButtons = () => {
    const isEn = wrapper.classList.contains('is-en');

    btns.forEach((btn) => {
      btn.textContent = isEn ? 'JP' : 'EN';
    });
  };

  btns.forEach((btn) => {
    btn.addEventListener('click', () => {
      wrapper.classList.toggle('is-en');
      updateButtons();
    });
  });

  updateButtons();
});


document.addEventListener('DOMContentLoaded', function () {

  const anchors = document.querySelectorAll('.js-anchor');
  // 固定ヘッダーの高さを取得（動的）
  function getHeaderHeight() {
    const header = document.querySelector('header');
    if (!header) return 0;
    return header.getBoundingClientRect().height;
  }
  anchors.forEach(anchor => {
    anchor.addEventListener('click', function(e) {
      e.preventDefault();

      const targetID = this.getAttribute('href');
      const target = document.querySelector(targetID);
      if (!target) return;

      const headerHeight = getHeaderHeight();
      const top = target.getBoundingClientRect().top + window.pageYOffset - headerHeight;

      window.scrollTo({
        top: top,
        behavior: 'smooth'
      });
    });
  });
});


document.addEventListener('DOMContentLoaded', function () {
  const nav = document.querySelector('.seasonalv2-nav');
  const header = document.querySelector('.header-menu');

  function updateNavTop() {
    if (!nav || !header) return;

    const headerHeight = header.offsetHeight - 2;
    const isSP = window.innerWidth <= 749; // SP判定（必要に応じて変更）

    if (isSP) {
      nav.style.position = 'fixed';
      nav.style.top = headerHeight + 'px';
    } else {
      // PC の時はリセットしたい場合
      nav.style.position = '';
      nav.style.top = '';
    }
  }

  // 初回実行
  updateNavTop();

  // リサイズ対応
  window.addEventListener('resize', updateNavTop);
});

document.addEventListener('DOMContentLoaded', function () {
  const nav = document.querySelector('.seasonalv2-nav');
  if (!nav) return;

  const SP_BREAKPOINT = 749; // SP判定の幅（必要なら変更してOK）
  let lastScrollY = window.scrollY;

  function handleScroll() {
    const currentY = window.scrollY;

    // PC のときは何もしない（クラスも一応リセット）
    if (window.innerWidth > SP_BREAKPOINT) {
      nav.classList.remove('is-hidden');
      lastScrollY = currentY;
      return;
    }

    // ちょっとした揺れ防止用のしきい値
    const diff = currentY - lastScrollY;

    if (diff > 5) {
      // 下向きスクロール → 隠す（margin-top: -100px）
      nav.classList.add('is-hidden');
    } else if (diff < -5) {
      // 上向きスクロール → 戻す（margin-top: 0）
      nav.classList.remove('is-hidden');
    }

    lastScrollY = currentY;
  }

  // スクロール時に実行
  window.addEventListener('scroll', handleScroll);

  // 画面サイズ変更時に状態リセット
  window.addEventListener('resize', function () {
    if (window.innerWidth > SP_BREAKPOINT) {
      nav.classList.remove('is-hidden');
    }
  });
});

document.addEventListener('DOMContentLoaded', () => {
  const title = document.querySelector('.grigri-title_wrapper.u-pc-ele');
  const bottomArea = document.querySelector('.grigri-bottomArea');

  if (!title || !bottomArea) return;

  const observer = new IntersectionObserver(
    ([entry]) => {
      title.classList.toggle('is-hidden', entry.isIntersecting);
    },
    {
      threshold: 0
    }
  );

  observer.observe(bottomArea);
});